import { appendPreloadFactory } from 'helpers/tools'
import { delegate } from 'helpers/events'

export default function () {
  let state = {
    loading: false,
    loader: null,
  }
  const preloadSetter = appendPreloadFactory()

  delegate('[data-loadmore]', 'mouseover', (e) => {
    const { target } = e
    const trigger = target.closest('[data-loadmore]')
    const config = parseConfig(trigger.dataset)
    const url = new URL(config.url, location)
    url.searchParams.append('_ajax', true)

    // prevent attacks
    if (!(location.hostname === url.hostname || !url.hostname.length)) return
    preloadSetter(url)
  })

  delegate('[data-loadmore]', 'click', (e) => {
    const { target } = e
    let trigger = target.closest('[data-loadmore]')
    const config = parseConfig(trigger.dataset)
    const url = new URL(config.url, location)
    url.searchParams.append('_ajax', true)

    // prevent attacks
    if (!(location.hostname === url.hostname || !url.hostname.length)) return

    trigger = toggleLoader(state, trigger, true)
    fetch(url.href, FETCH_CONFIG)
      .then(async (resp) => {
        if (!resp.ok) throw new Error('Failed loading')
        return resp.text()
      })
      .then((content) => {
        trigger.outerHTML = config.selector
          ? parseHtml(content).querySelector(config.selector).innerHTML
          : content
        trigger = toggleLoader(state, null, false)
      })
      .catch((e) => {
        console.log(e)
        trigger = toggleLoader(state, null, false)
      })

    e.preventDefault()
  })
}

const toggleLoader = (state, elem, force) => {
  state.loading = typeof force === 'undefined' ? !state.loading : force

  if (state.loader) {
    state.loader.remove()
    state.loader = null
  }
  if (state.loading) {
    const loader = document.createElement('div')
    loader.classList.add(
      'flex', 'justify-center', 'w-full', 'pt-6', 'pb-24',
    )
    loader.innerHTML = LOADER_HTML
    elem.replaceWith(loader)
    elem = loader
    state.loader = loader
  }

  return elem
}

const parseConfig = (dataset) => {
  const rawConfig = JSON.parse(dataset.loadmore || '{}')
  return typeof rawConfig === 'string' ? { url: rawConfig } : rawConfig
}

const parseHtml = (str) => {
  var tmp = document.implementation.createHTMLDocument()
  tmp.body.innerHTML = str
  return tmp.body
}

const FETCH_CONFIG = {
  mode: 'cors',
  credentials: 'same-origin',
}

const LOADER_HTML = `
  <div class="loader text-blue-base animate-spin"></div>
`
